import { DateTime, Interval } from 'luxon';

import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import { CampaignsOrdersAndSalesResponse, CampaignWithType } from './types';
import { getBaseUrl, getDateRangeForApiCall } from '../../utils';

export const getCampaignsSalesAndOrders = async (
  entityType: Extract<EntityType, 'venue' | 'merchant'>,
  entityId: string,
  campaignList: CampaignWithType[],
) => {
  const interval = Interval.fromDateTimes(DateTime.now().minus({ months: 6 }), DateTime.now());
  const dateRangeForApiCall = getDateRangeForApiCall(interval);

  const { data } = await merchantGatewayApi.post<CampaignsOrdersAndSalesResponse>(
    `${getBaseUrl(entityType, entityId)}/campaigns-performance/sales`,
    /* @link Request body backend schema https://github.com/creditornot/merchant-analytics-api/blob/8459e0b4dd606cdcc977d59a8922107090fe678b/insights/src/main/kotlin/com/wolt/merchantanalyticsapi/insights/http/CampaignsOrdersAndSalesRequest.kt#L5 */
    {
      startDate: dateRangeForApiCall.start_date,
      endDate: dateRangeForApiCall.end_date,
      campaigns: campaignList,
    },
  );
  return data;
};
